import { render, staticRenderFns } from "./BankTransactionsSidebar.vue?vue&type=template&id=d4b9ba62&scoped=true&"
import script from "./BankTransactionsSidebar.vue?vue&type=script&lang=js&"
export * from "./BankTransactionsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactionsSidebar.vue?vue&type=style&index=0&id=d4b9ba62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9ba62",
  null
  
)

export default component.exports